'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Sprite) {
  _inherits(_class, _Phaser$Sprite);

  function _class(_ref) {
    var game = _ref.game,
        x = _ref.x,
        y = _ref.y,
        name = _ref.name;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game, x, y, name));

    _this.name = name;
    game.physics.arcade.enable(_this);
    _this.body.collideWorldBounds = true;
    _this.body.gravity.y = _config2.default.world.gravity;
    _this.anchor.setTo(0.5, 0.5);
    _this.emitter = game.add.emitter(x, y, 100);
    _this.emitter.makeParticles('diamond');
    _this.emitter.gravity = 0;
    _this.emitter.start(true, 500, null, 10);
    _this.timer = 0.0;
    return _this;
  }

  _createClass(_class, [{
    key: 'update',
    value: function update() {
      var dt = this.game.time.physicsElapsed;
      this.timer += dt;
      if (this.timer >= 1.0) {
        this.emitter.x = this.x;
        this.emitter.y = this.y;
        this.emitter.start(true, 500, null, 10);
        this.timer = 0.0;
      }
    }
  }]);

  return _class;
}(_phaser2.default.Sprite);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Item.js
// module id = 91
// module chunks = 0